var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"file-upload",on:{"click":_vm.uploadFile}},[_c('div',[_c('img',{attrs:{"width":"50px","src":_vm.image === 'fileupload'
            ? require(`../../../assets/${_vm.image}.svg`)
            : _vm.image}})]),_vm._m(0)]),_c('input',{ref:"image",attrs:{"type":"file","accept":"image/*","hidden":""},on:{"change":_vm.selectImage}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Upload")]),_c('p',[_vm._v("Supports: PNG, JPEG")])])
}]

export { render, staticRenderFns }